import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import About from "@/components/About";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Policy from "@/pages/Policy";
import { scrollToTop } from "@/lib/scroll";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-[#0A0A0B] px-6 text-center">
                    <div>
                        <p className="font-display text-2xl font-bold text-[#BCE55C]">fynary.</p>
                        <p className="mt-3 text-[#98989D]">Something went wrong. Refresh to try again.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        scrollToTop();
    }, [pathname]);
    return null;
}

const Home = () => (
    <main>
        <Hero />
        <Marquee />
        <Features />
        <HowItWorks />
        <About />
        <Faq />
        <Contact />
    </main>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, autoRaf: true });
        window.__lenis = lenis;
        return () => {
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="App min-h-screen bg-[#0A0A0B] font-sans text-white">
                <BrowserRouter>
                    <ScrollManager />
                    <Nav />
                    <div className="grain" aria-hidden="true" />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/privacy" element={<Policy doc="privacy" />} />
                        <Route path="/terms" element={<Policy doc="terms" />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                    <Footer />
                </BrowserRouter>
            </div>
        </ErrorBoundary>
    );
}

export default App;
